'use client';

import { Box, Switch, Typography } from '@mui/material';
import React from 'react';
import { SubscriptionSettingsRow } from './subscriptionSettingsLayout';

type Props = {
	facilityEnabled: boolean;
	enabled: boolean;
	editMode: boolean;
	onChange: (enabled: boolean) => void;
};

export const SubscriptionAutoAccessControl = ({ facilityEnabled, enabled, editMode, onChange }: Props) => (
	<SubscriptionSettingsRow>
		<Box>
			<strong>Monthly Auto Activation/Deactivation</strong>
		</Box>
		<Box>
			<Switch
				checked={facilityEnabled && enabled}
				disabled={!editMode || !facilityEnabled}
				onChange={(_, checked) => onChange(checked)}
				inputProps={{ 'aria-label': 'Auto Activation/Deactivation' }}
				data-cy='auto-access-enabled-switch'
			/>
			{!facilityEnabled && (
				<Typography variant='body2' color='text.secondary'>
					Enable Auto Activation/Deactivation at the facility to change this setting.
				</Typography>
			)}
		</Box>
	</SubscriptionSettingsRow>
);
